import { createSlice, current } from '@reduxjs/toolkit'

export const mainSlice = createSlice({
  name: 'main',
  initialState: {
    darkMode: false,
    direction: localStorage.getItem('direction') || 'ltr',
    preloader: true,
    sidebar: 1,
    history: [],
    quickSetupStep: 1,
    currency: {
      currencyCode:
        localStorage.getItem('currencyCode') ||
        localStorage.getItem('defaultCurrencyCode'),
      id:
        localStorage.getItem('currencyId') ||
        localStorage.getItem('defaultCurrencyId'),
    },
    defaultCurrency: {
      currencyCode: localStorage.getItem('defaultCurrencyCode'),
      id: localStorage.getItem('defaultCurrencyId'),
    },
    pOSystemName: null,
    isLoading: false,
    environmentAlertData: [],
    audits: { items: [], totalCount: 0 },
  },
  reducers: {
    directionFun: (state, action) => {
      state.direction = action.payload
    },
    changeMode: (state, action) => {
      state.darkMode = action.payload
      localStorage.setItem('dark', action.payload)
    },
    changePreloader: (state, action) => {
      state.preloader = action.payload
    },
    addToHistory: (state, action) => {
      state.history = [...state.history, action.payload]
    },
    setCurrentCurrencyCodeAndId: (state, action) => {
      const { id, currencyCode } = action.payload
      state.currency = { id, currencyCode }
    },
    setDefaultCurrencyCodeAndId: (state, action) => {
      const { id, currencyCode } = action.payload
      state.defaultCurrency = { id, currencyCode }
    },
    setProductOwner: (state, action) => {
      state.pOSystemName = action.payload
    },
    deleteProductOwner: (state) => {
      state.pOSystemName = null
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setEnvironmentAlertData: (state, action) => {
      state.environmentAlertData = action.payload
    },
    setQuickSetupStep: (state, action) => {
      state.quickSetupStep = action.payload
    },
    setAuditsData: (state, action) => {
      const allAudits = JSON.parse(JSON.stringify(current(state.audits)))
      if (action?.payload?.items) {
        action.payload.items.forEach((item) => {
          // Add new item if it doesn't already exist
          if (!allAudits.items[item.id]) {
            allAudits.items[item.id] = item
          }
        })
      }

      state.audits.items = allAudits.items
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  directionFun,
  changePreloader,
  deleteProductOwner,
  changeMode,
  addToHistory,
  setCurrentCurrencyCodeAndId,
  setProductOwner,
  setLoading,
  setEnvironmentAlertData,
  setAuditsData,
  setDefaultCurrencyCodeAndId,
  setQuickSetupStep,
} = mainSlice.actions

export default mainSlice.reducer
